<template>
  <div class="header-layout">
    <t-head-menu :class="menuCls" expandType="popup">
      <template #logo>
        <div class="header-logo-container" @click="handleNav(homePath)">
          <img class="logo_icon" src="@/assets/images/logo_white.png" alt="" />
        </div>
      </template>
      <template #operations>
        <div class="operations-container">
          <!-- 向平台反馈 -->
          <!-- <t-tooltip placement="bottom">
            <div class="feedback-btn" @click="navToFeedback">
              <chat-message-icon /><span>向平台反馈</span>
            </div>
          </t-tooltip> -->
          <!-- 退出登录 -->
          <t-dropdown :min-column-width="140" trigger="click">
            <div class="header-user-btn" >
              <user-circle-icon class="header-user-avatar" />
              <chevron-down-icon />
            </div>
            <template #dropdown>
              <t-dropdown-menu>
                <t-dropdown-item class="operations-dropdown-container-item" @click="openSwitchEnterprise">
                  <swap-icon />切换企业
                </t-dropdown-item>
                <t-dropdown-item class="operations-dropdown-container-item" @click="handleLogout">
                  <poweroff-icon />退出登录
                </t-dropdown-item>
              </t-dropdown-menu>
            </template>
          </t-dropdown>
        </div>
      </template>
    </t-head-menu>
    <switch-enterprise-dialog
      :visible.sync="switchVisible"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import {
  // ViewListIcon,
  UserCircleIcon,
  PoweroffIcon,
  ChevronDownIcon,
  SwapIcon,
  // ChatMessageIcon
} from 'tdesign-icons-vue';
import SwitchEnterpriseDialog from './SwitchEnterpriseDialog.vue';
import { resolveHomePath, clearHasDonationFlag } from '@/utils/entStatus';
import { clearEntInitInfoCache } from '@/utils/api';
import { clearDonationOverviewCache } from '@/api/donation';

export default Vue.extend({
  components: {
    SwitchEnterpriseDialog,
    UserCircleIcon,
    PoweroffIcon,
    ChevronDownIcon,
    SwapIcon,
    // ChatMessageIcon
  },
  props: {
    layout: {
      type: String,
      default: 'top',
    },
    showLogo: {
      type: Boolean,
      default: true,
    },
    menu: {
      type: Array,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    isCompact: {
      type: Boolean,
      default: false,
    },
    maxLevel: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      switchVisible: false,
    };
  },
  computed: {
    homePath() {
      return resolveHomePath();
    },
    showMenu() {
      return !(this.layout === 'mix' && this.showLogo === 'side');
    },
    menuCls() {
      return [
        {
          [`header-menu`]: !this.isFixed,
          [`header-menu-fixed`]: this.isFixed,
          [`header-menu-fixed-side`]: this.layout === 'side' && this.isFixed,
          [`header-menu-fixed-side-compact`]: this.layout === 'side' && this.isFixed && this.isCompact,
        },
      ];
    },
  },
  methods: {
    openSwitchEnterprise() {
      // 等 dropdown 收起后再开弹窗，避免同一次 click 落到 overlay 上立刻关掉
      window.setTimeout(() => {
        this.switchVisible = true;
      }, 80);
    },
    handleLogout() {
      const leave = () => {
        sessionStorage.removeItem('nolocate');
        clearHasDonationFlag();
        clearEntInitInfoCache();
        clearDonationOverviewCache();
        this.$router.push('/login');
      };
      const logout = window.GYL && window.GYL.GYLogout;
      if (typeof logout === 'function') {
        logout().then(leave).catch(leave);
      } else {
        leave();
      }
    },
    handleNav(url) {
      this.$router.push(url);
    },
    navToFeedback() {
      // 去反馈
    }
  },
});
</script>
<style lang="less">
@import '@/styles/variables.less';

.header-menu {
  // flex: 1 1 1;
  // display: inline-flex;
}

.operations-container {
  display: flex;
  align-items: center;
  margin-right: 12px;
  color: white;
  cursor: pointer;
  &:hover{
    background-color: none;
  }
  .t-popup__reference {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .feedback-btn {
    margin-right: 25px;
    span {
      margin-left: 5px;
    }
  }

  .header-user-btn {
    margin: 0;
  }

  .t-icon {
    font-size: 20px;

    &.general {
      margin-right: 16px;
    }
  }
}

.header-operate-left {
  display: flex;
  margin-left: 20px;
  align-items: normal;
  line-height: 0;

  .collapsed-icon {
    font-size: 20px;
  }
}

.header-logo-container {
  // width: 184px;
  height: 22px;
  display: flex;
  margin-left: 24px;
  color: var(--td-text-color-primary);

  .logo_icon {
    height: 22px;
  }

  .t-logo {
    width: 100%;
    height: 100%;

    &:hover {
      cursor: pointer;
    }
  }

  &:hover {
    cursor: pointer;
  }
}

.header-user-account {
  display: inline-flex;
  align-items: center;
  color: var(--td-text-color-primary);

  .t-icon {
    margin-left: 4px;
    font-size: 16px;
  }
}

.t-head-menu__inner {
  // border-bottom: 1px solid var(--td-border-level-1-color);
  // position: absolute;
  width: 100%;
  height: 60px;
  display: flex;
  // padding: 10px 24px;
  justify-content: space-between;
  align-items: center;
  background: var(--100, #ED3142);
}

.t-menu--light {
  .header-user-account {
    color: var(--td-text-color-primary);
  }
}

.t-menu--dark {
  .t-head-menu__inner {
    border-bottom: 1px solid var(--td-gray-color-10);
  }

  .header-user-account {
    color: rgba(255, 255, 255, 0.55);
  }

  // .t-button {
  //   --ripple-color: var(--td-gray-color-10) !important;

  //   &:hover {
  //     background: var(--td-gray-color-12) !important;
  //   }
  // }
}

.operations-dropdown-container-item {
  width: 100%;
  display: flex;
  align-items: center;

  .t-icon {
    margin-right: 8px;
  }

  .t-dropdown__item {
    .t-dropdown__item__content {
      display: flex;
      justify-content: center;
    }

    .t-dropdown__item__content__text {
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }

  .t-dropdown__item {
    width: 100%;
    margin-bottom: 0px;
  }

  &:last-child {
    .t-dropdown__item {
      margin-bottom: 8px;
    }
  }
}
</style>

<style lang="less" scoped>
.t-button .t-ripple,
.t-button .t-ripple__inner {
  display: none !important;
  background: none !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
</style>
